<template>
  <div class="index-page container">
    <n-card :loading="$var('loadImage')" style="max-width: 1000px;">
      <h3 slot="header">Изображение</h3>
      <n-image inline centered bg :src="image" />
    
      <n-form @submit="saveImage">
        <n-items>
          <n-upload title="Загрузить новое изображение" :value.sync="newImage" />
          <br />
          <n-button color="primary" type="submit">Загрузить</n-button>
        </n-items>
      </n-form>
    </n-card>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data: () => ({
    image: null,
    newImage: null,
  }),
  computed: {
    modelId() {
      return this.$route.params.id
    },
  },
  mounted() {
    this.loadModel()
  },
  methods: {
    loadModel() {
      this.$var('load', true)
      $api.app.images.get(this.modelId).then((response) => {
        const result = response.data.content
        this.image = result.image
        this.$form.init(result)
        this.$form.set('image', undefined)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    saveImage() {
      this.$var('loadImage', true)
      $api.files.create({ file: this.newImage, }).then((file) => {
        $api.app.images.edit(this.modelId, { image: file.data.content.id, }).then((result) => {
          this.image = result.data.content.image
          this.newImage = null
        }).finally(() => {
          this.$var('loadImage', false)
        })
      }).catch(() => {
        this.$var('loadImage', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .index-page {
  
    --n-image-width: 180px;
    --n-image-height: 200px;
    
    .image {
      border: 2px solid red;
    }
  }
</style>
